export const minimumCharsError = { minimumChars: true };

export function hasMinimumChars(str: string, minChars = 8): boolean {
  return str.length >= minChars;
}
